<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import InvoiceTable from "../../../components/datatables/InvoiceTable.vue";

export default {
    page: {
        title: "Monthly Statement Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Monthly Statement Listing",
            items: [
                {
                text: "Monthly Statement Listing",
                href: "/",
                },
            ],
        };
    },
    
    components: {
        Layout,
        PageHeader,
        InvoiceTable,
    },    
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Monthly Statement Listing</h5>
                        </div>
                    </div>
                </div>
            </div>
            <InvoiceTable />
        </div>
    </Layout>
</template>